import {GET_PLANS} from "../../../services/types/PlansTypes";

const initialState = {

    plans: []

};

export const PlansReducer=(state=initialState, action) => {
    const {payload, type} = action;
    if (type === GET_PLANS) {
        return {

            ...state,
            plans: payload

        };
    } else {
        return state;
    }

};
export default PlansReducer;